/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const bankDetailsPostRequestSchema = z.object({
  account_number: z.string(),
  sort_code: z.string(),
});
